import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { Quote } from 'lucide-react'

export type TestimonialsProps = Record<string, never>

const testimonials = [
  {
    name: 'Constantin Predescu',
    company: 'GoJoe',
    companyUrl: 'https://www.gojoe.com',
    role: 'CTO',
    content: `The paid package has been a reliable and well-maintained solution for our production app and the Expo-compatible setup saved us significant integration time. The documentation and ongoing support make it a solid choice for teams building real-world apps.`,
    avatar: 'CP',
  },
  {
    name: 'Gabriel Ferraz',
    company: 'Creem.io',
    companyUrl: 'https://creem.io',
    role: 'Founder',
    content:
      "As a fast-moving startup, we don't want to waste time on half-baked dependencies. We were happy to purchase the license - the quick setup meant we had user auth running in no time and could focus on building core features.",
    avatar: 'GF',
  },
  {
    name: 'Nathan Pierce',
    company: 'Memlane.app',
    companyUrl: 'https://memlane.app',
    role: 'Founder',
    content:
      'The thought of coding Google sign into my app and making it cross platform felt daunting. Thankfully, I stumbled on Universal sign in and was able to get up and running quickly. Integration of the package was a breeze!',
    avatar: 'NP',
  },
]

export const Testimonials = ({}: TestimonialsProps) => {
  return (
    <section
      id="testimonials"
      className="mb-16 scroll-mt-24"
      aria-labelledby="testimonials-heading"
    >
      <h2
        id="testimonials-heading"
        className="text-3xl font-semibold mb-8 text-center text-foreground"
      >
        Trusted by Developers
      </h2>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10 flex-wrap">
        <div className="inline-flex items-center gap-2 px-4 py-2">
          <svg
            className="w-5 h-5 text-primary"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
            />
          </svg>
          <span className="font-semibold text-foreground">1.5 mil+</span>
          <span className="text-muted-foreground">downloads of the premium package</span>
        </div>
        <a
          href="https://github.com/react-native-google-signin/google-signin"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-4 py-2"
        >
          <img
            src="https://img.shields.io/github/stars/react-native-google-signin/google-signin?style=social"
            alt="GitHub stars"
            className="h-5"
          />
        </a>
      </div>
      <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
        {testimonials.map((testimonial) => (
          <Card
            key={testimonial.name}
            className="group hover:border-primary transition-all duration-300 hover:shadow-lg"
          >
            <CardContent className="pt-6">
              <div className="mb-4">
                <Quote className="w-8 h-8 text-primary/35" aria-hidden="true" />
              </div>
              <p className="text-muted-foreground mb-6 italic">"{testimonial.content}"</p>
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-foreground font-semibold">
                  {testimonial.avatar}
                </div>
                <div>
                  <p className="font-semibold text-foreground">{testimonial.name}</p>
                  <p className="text-sm text-muted-foreground">
                    {testimonial.role}
                    {testimonial.company !== 'Independent Developer' && (
                      <>
                        {' '}
                        at{' '}
                        {testimonial.companyUrl ? (
                          <a
                            href={testimonial.companyUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary hover:underline"
                          >
                            {testimonial.company}
                          </a>
                        ) : (
                          <span>{testimonial.company}</span>
                        )}
                      </>
                    )}
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  )
}
